import { useSelector } from 'react-redux'
import { useReservationsEffect } from 'Checkout/Hooks/useReservationsEffect'
import { useReservationsPricing } from 'Checkout/Hooks/useReservationsPricing'
import FontAwesomeIcon from 'Shared/FontAwesomeIcon/FontAwesomeIcon'
import ReservationTotal from 'Checkout/Components/ReservationDetails/ReservationTotal/ReservationTotal'
import Reservations from 'Checkout/Components/Shared/CartSummary/Reservations'

const CartSummary = () => {
  const fetchPrice = useReservationsPricing()
  const { membershipApplied } = useSelector(state => state.payment)

  useReservationsEffect(() => {
    fetchPrice()
  })

  return (
    <div className="cart-summary bg-white border border-2 p-3 rounded">
      <div className="d-flex justify-content-between align-items-center">
        <span className="text-muted text-uppercase">Cart Summary</span>

        {membershipApplied && (
          <span className="badge bg-premium rounded rounded-pill px-4 py-3">
            <FontAwesomeIcon icon="key" className="me-2" />

            Active Membership
          </span>
        )}
      </div>

      <hr />

      <Reservations />

      <ReservationTotal />
    </div>
  )
}

export default CartSummary
